'use client';

import { __styles } from '@griffel/react';
import { typographyStyles } from '@fluentui/react-theme';
export const title2ClassNames = {
  root: 'fui-Title2'
};
/**
 * Styles for the root slot
 */
export const useTitle2Styles = /*#__PURE__*/__styles({
  root: {
    Bahqtrf: "fk6fouc",
    Be2twd7: "fojgt09",
    Bhrd7zp: "fl43uef",
    Bg96gwp: "fcen8rp"
  }
}, {
  d: [".fk6fouc{font-family:var(--fontFamilyBase);}", ".fojgt09{font-size:var(--fontSizeHero700);}", ".fl43uef{font-weight:var(--fontWeightSemibold);}", ".fcen8rp{line-height:var(--lineHeightHero700);}"]
});